import {
  getRawOpenAIAdsOppref,
  OPENAI_ADS_ATTRIBUTION_COOKIE,
} from "~~/shared/lib/openaiAdsAttribution";

const NINETY_DAYS_IN_SECONDS = 60 * 60 * 24 * 90;

export default defineNuxtRouteMiddleware((to) => {
  const oppref = getRawOpenAIAdsOppref(to.fullPath);
  if (!oppref) return;

  const attributionCookie = useCookie<string | null>(OPENAI_ADS_ATTRIBUTION_COOKIE, {
    decode: value => value,
    encode: value => value ?? "",
    maxAge: NINETY_DAYS_IN_SECONDS,
    path: "/",
    sameSite: "lax",
    secure: !import.meta.dev,
  });

  attributionCookie.value = oppref;
});
